import { Component, OnInit } from '@angular/core';

import { FieldCommonComponent } from '../field-common.component';

@Component({
  selector: 'app-input-editor',
  templateUrl: './input-editor.component.html',
  styleUrls: ['./input-editor.component.scss'],
})
export class InputEditorComponent
  extends FieldCommonComponent
  implements OnInit
{
  public caracteres = 4000;

  constructor() {
    super();
  }

  ngOnInit() {}

  editorInit(event: any) {
    const quill = event.editor;
    const toolbar = quill.getModule('toolbar');

    toolbar.addHandler('image', () => {
      const value = prompt('URL da imagem');

      if (this.control.value) {
        this.control.setValue(
          `${this.control.value} <img alt="img" src="${value}">`
        );
      } else {
        this.control.setValue(`<img alt="img" src="${value}">`);
      }
    });

    if (quill.container) {
      const text = quill.container.getElementsByClassName("ql-editor")[0];
      if (text.textContent && text.textContent.length > 0) {
        this.caracteres = this.caracteres - text.innerHTML.length;
      }
    }
  }

  contadorCaracteres(event: any) {
    if (event.textValue === '') {
      this.caracteres = 4000;
    } else {
      this.caracteres = 4000 - event.htmlValue.length;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/formulario/input-editor/input-editor.component.ts